import React from 'react';
import { Link } from 'react-router-dom';
import HttpManager from '../utils/HttpManager';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'

function Credentials() {
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});

    const UpdateCredentials = async () => {
        const newErrors = {};

        if (!password.trim()) newErrors.password = 'Password is required';
        else if (password.trim().length < 8) newErrors.password = 'Password must be 8 characters long';
        else if (password.trim().length > 15) newErrors.password = 'Password can not exceed 15 characters';

        if (!confirmPassword.trim()) newErrors.confirmPassword = 'Confirm password is required';

        if (password.trim() !== confirmPassword.trim()) newErrors.confirmPassword = 'Password & Confirm Password does not match';

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            // Submit form or perform action

            let registration = JSON.parse(localStorage.getItem("Registration"));
            let credentialsModel =
            {
                "Registration": registration,
                "UserCredentials": {
                    UserEmail: registration.Email,
                    Password: password,
                    ConfirmPassword: confirmPassword,
                }
            };

            let updateCredentialsResponse;
            try {
                updateCredentialsResponse = await new HttpManager(navigate).post('/User/UpdateCredentials', credentialsModel);

                if (updateCredentialsResponse.IsSuccess === true && updateCredentialsResponse.Message === "Credentials successfully updated") {
                    navigate('/Dashboard');
                }
                else {
                    Swal.fire({
                        title: "Failed To Update Credentials",
                        text: updateCredentialsResponse.Message,
                        icon: "error"
                    });
                }
            }
            catch (error) {
                Swal.fire({
                    title: "Failed To Update Credentials",
                    text: "Failed to update credentials due to technical reason.",
                    icon: "error"
                });
            }
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 w-100">
            <main className="form-signin w-100 m-auto">
                <form>
                    <h5 className="h5 mb-3 fw-normal text-center">Update Your Login Credentials</h5>

                    <div className="form-floating my-3">
                        <input
                            type="password"
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                            id="txtPassword"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <label htmlFor="txtPassword">Password</label>
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>

                    <div className="form-floating my-3">
                        <input
                            type="password"
                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                            id="txtConfirmPassword"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <label htmlFor="txtConfirmPassword">Confirm Password</label>
                        {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                    </div>

                    <button className="btn btn-primary w-100 py-2" type="button" onClick={UpdateCredentials}>
                        Update Credentials
                    </button>
                    <p className="mt-5 mb-3 text-body-secondary">decipherX © 2026</p>
                </form>
            </main>
        </div>
    );
}

export default Credentials;